import { useAtom, useAtomValue } from "jotai";
import { useRouter } from "next/router";

import { checkIsContainsPlusQueryString } from "~/components/article/article-render/plus/helpers";
import { hamburgerMenuAtom } from "~/components/hamburger-menu/atoms";
import { headerAllMenuAtom } from "~/components/header/header-oneline-menu-container/header-all-menu/atoms";
import { loginDialogAtom } from "~/components/login-dialog/atoms";
import { gdprAtom } from "~/components/tracking/gdpr";
import { useArticleCommentLink } from "~/lib/hooks";

export const useNeedToShowAcquisitionPopupContainerWrapper = () => {
  const { isAccepted: isAcceptedGDPR } = useAtomValue(gdprAtom);
  const router = useRouter();

  const loginDialogState = useAtom(loginDialogAtom);
  const hamburgerMenuAtomState = useAtomValue(hamburgerMenuAtom);
  const headerAllMenuPopupState = useAtomValue(headerAllMenuAtom);

  const { isCommentLink } = useArticleCommentLink();

  if (checkIsContainsPlusQueryString(router)) return false;

  const needToShow =
    !loginDialogState[0].isVisible &&
    isAcceptedGDPR &&
    !hamburgerMenuAtomState.isOpen &&
    !isCommentLink() &&
    !headerAllMenuPopupState.isOpen;

  return needToShow;
};
